export const defaultValForFieldType = type => {
	switch (type) {
		case 'email':
		case 'textarea':
		case 'textfield':
			return '';
		case 'checkbox':
			return false;
		default:
			return null;
	}
};
